import {abs, round} from '@republic/foundation/lang/number';

const
    isDate = type => (
        (name => (
            value => toString.call(value) === name))(
                `[object ${type}]`)),
    relative = (date) => {
        let delta = 0.001 * ((isDate(date) ? date : new Date(date)) - new Date()),
            seconds = abs(delta),
            minutes = round(seconds / 60),
            hours = round(seconds / (60 * 60)),
            days = round(seconds / (24 * 60 * 60));

        return (
            delta < 0 ?
                (minutes < 1 ?
                    'Less than a minute ago' :
                    (minutes === 1 ?
                        'A minute ago' :
                        (minutes < 60 ?
                            (minutes + ' minutes ago') :
                            (hours === 1 ?
                                'An hour ago' :
                                (hours < 24 ?
                                    (hours + ' hours ago') :
                                    (days === 1 ?
                                        'Yesterday' :
                                        (days + ' days ago'))))))) :
                (minutes < 1 ?
                    'Less than a minute from now' :
                    (minutes === 1 ?
                        'A minute from now' :
                        (minutes < 60 ?
                            (minutes + ' minutes from now') :
                            (hours === 1 ?
                                'An hour from now' :
                                (hours < 24 ?
                                    (hours + ' hours from now') :
                                    (days === 1 ?
                                        'Tomorrow' :
                                        (days + ' days from now'))))))));
    };

export {relative};
